import vars from "utils/vars";

// Helper function to check if user data is complete (not a placeholder)
export const isUserDataComplete = (user) => {
	if (!user || !user.id) return false;

	// If user has placeholder data, it's not complete
	if (user.id === "pending" && user.authenticated_via_token) return false;

	// Check for essential user properties that indicate real user data
	return Boolean(user.email || user.name || user.first_name || user.tenant);
};

export const handleTokenFromQueryParams = (searchParams) => {
	// Parse query parameters
	const params = new URLSearchParams(searchParams);
	// JWT for session bootstrap only — do not use `token` (reserved for other flows, e.g. booking).
	const token = params.get("auth_token");

	// If token exists in query params, save it to localStorage immediately
	if (token) {
		// Save token immediately
		localStorage.setItem(vars.localStorage.fieldsName.token, token);

		// Save a placeholder user object to prevent redirections
		// This will be replaced with real user data when the API call completes
		const existingUser = localStorage.getItem(vars.localStorage.fieldsName.user);
		if (!existingUser || existingUser === "{}") {
			const placeholderUser = {
				id: "pending",
				authenticated_via_token: true,
				token_timestamp: Date.now(),
			};
			localStorage.setItem(vars.localStorage.fieldsName.user, JSON.stringify(placeholderUser));
		}

		return token;
	}

	return null;
};
